/**
 * @fileoverview Syndicator Showdown — Share artwork mapping
 * @module utils/shareArtwork
 *
 * Maps a share "artwork type" to the premium dark background used behind
 * share cards/modals (web/public/*.png — same assets already used by
 * in-app notification cards, see notificationHelpers.js). Kept as a pure,
 * dependency-free lookup so both React components and tests can use it
 * without pulling in Firestore/React.
 */

export const SHARE_ARTWORK_TYPES = {
  STABLE:      'stable',
  INVITE:      'invite',
  WINNER:      'winner',
  TOP5:        'top5',
  LEADERBOARD: 'leaderboard',
};

const ARTWORK_BY_TYPE = {
  stable:      '/stable-share-dark.png',
  invite:      '/stable-share-dark.png',
  winner:      '/top1-dark.png',
  top5:        '/top5-dark.png',
  leaderboard: '/stable-share-dark.png',
};

/**
 * @param {string} artworkType - one of SHARE_ARTWORK_TYPES values
 * @returns {string} public path to the background image (never null — falls
 *   back to the generic stable-share artwork for unknown types)
 */
export function getShareArtwork(artworkType) {
  return ARTWORK_BY_TYPE[artworkType] || ARTWORK_BY_TYPE.stable;
}

/**
 * Picks the correct result artwork type from a finishing position —
 * 1st -> winner, 2nd-5th (or any placing) -> top5. Mirrors
 * notificationHelpers.js#resolveResultSplit so share cards and in-app
 * notification cards always agree on which artwork a given result gets.
 *
 * @param {number|null|undefined} finishingPosition
 * @returns {'winner'|'top5'}
 */
export function getResultArtworkType(finishingPosition) {
  return finishingPosition === 1 ? SHARE_ARTWORK_TYPES.WINNER : SHARE_ARTWORK_TYPES.TOP5;
}
